export const LOCALIZATION_SCOPE = 'firefly-globalization';
